export default __webpack_public_path__ + "static/media/jp.91fb3fc7.jpeg";